import type {
  MemberPaymentsSearchFilters,
  MemberPaymentsSearchParams
} from '@library/types/memberPayments';
import { useCallback, useState } from 'react';
import { DEFAULT_MEMBER_PAYMENTS_FILTERS } from '@bo-constants/member/memberPayments';
import type { DateRange } from '@library/types/dates';
import { isTimeAfter } from '@library/utils/dateTime';

export function useMemberPaymentsFilters() {
  const [paymentsSearchFilters, setPaymentsSearchFilters] =
    useState<MemberPaymentsSearchFilters>(DEFAULT_MEMBER_PAYMENTS_FILTERS);

  const handlePaymentsDateRange = useCallback(
    (value: DateRange) => {
      const { fromDate: newFromDate, toDate: newToDate } = value;

      const newSelectedEndDate =
        newToDate &&
        isTimeAfter({ dateValue: newFromDate, dateToCompareAgainst: newToDate })
          ? newFromDate
          : newToDate;

      setPaymentsSearchFilters({
        ...paymentsSearchFilters,
        dateRange: {
          fromDate: newFromDate,
          toDate: newSelectedEndDate
        }
      });
    },
    [paymentsSearchFilters]
  );

  const handleChangePaymentsFilter = useCallback(
    ({ key, value }: MemberPaymentsSearchParams) => {
      if (key === 'dateRange') {
        handlePaymentsDateRange(value as DateRange);
        return;
      }

      setPaymentsSearchFilters({
        ...paymentsSearchFilters,
        [key]: value
      });
    },
    [handlePaymentsDateRange, paymentsSearchFilters]
  );

  const handleResetPaymentsFilters = useCallback(() => {
    setPaymentsSearchFilters(DEFAULT_MEMBER_PAYMENTS_FILTERS);
  }, []);

  return {
    onChangePaymentsFilter: handleChangePaymentsFilter,
    onResetPaymentsFilters: handleResetPaymentsFilters,
    paymentsSearchFilters
  };
}
